module.exports = __webpack_public_path__ + "media/images/email-members-b2e2488fdaf5aa0fcc46a2a32d2bd37b.svg";